export default interface ConfirmationProps {
  data: {
    [key: string]: any;
  };
  dataSchema?: {
    [key: string]: any;
  };
  confirmationSections?: ConfirmationSections;
  confirmationTitle?: ConfirmationTitle;
  dataPointer?: string;
  iterateObjects?: boolean;
  startIndex?: number;
  dataCy?: string;
  texts?: {
    [key: string]: string;
  };
}

export interface ConfirmationSections {
  [key: string]: ConfirmationSection;
}

export interface ConfirmationSection {
  sectionTitle: string;
  sectionData: (string | { component: string; properties: Record<string, any> })[];
  bold?: string[];
  editable: boolean;
  deletable?: boolean;
}

export interface ConfirmationTitle {
  keys?: string[];
  title?: string;
}

export enum WildCards {
  index = '{{index}}',
  numeration = '{{numeration}}',
}
